<template>
  <div class="hvh-card--rounded v-sheet theme--light">
    <h2 class="text-xs-center mb-4" v-if="text">{{ text }}</h2>
    <div class="hvh-relative">
      <HvhChart :visualization="visualization" :options="chartOptions" :isEditMode="true" :height="height" @item-clicked="$emit('checked-changed', $event, data)" />
      <Loader v-if="isFiltering" />
    </div>
  </div>
</template>
  
<script>
import { Debouncer, hashCode } from '../../../libraries/common';
import HvhChart from '../../charts/HvhChart.vue';
export default {
  components: { HvhChart },
  props: ['data', 'filterObject', 'text', 'isChecked', 'options', 'isFiltering', 'height'],
  data() {
    return {
      chartOptions: this.options,
      debouncer: new Debouncer(2000),
    }
  },
  computed: {
    visualization() {
      return {
        visualization_type: 'donutchart',
        data: this.data.map(f => ({
          ...f,
          unchecked: !this.isChecked(f),
        })),
      };
    },
    filterHash() {
      return hashCode(this.filterObject || {});
    }
  },
  watch: {
    filterHash() {
      this.debouncer.clear().push(() => this.$emit('refresh-data', this.filterObject));
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisDonutchartFilter'] = this;
    this.$emit('chart-created', this.filterObject);
  },
}
</script>
